import { GroupPermission } from '@reducers/data/shareStatuses/groups';
import { SharedContact } from '@models/SharedContact';
import { OrderedMap } from 'immutable';
import { BaseGroup } from './Group';
import { ID } from '@app/types';

export class SharedGroup extends BaseGroup {
  sharerIsSelf: boolean;
  sharerDisplayName: string;
  sharedPublicly: boolean;
  publicPermissions: GroupPermission[];
  wasSharedDirectly: boolean;
  contactsMap: OrderedMap<ID, SharedContact>;

  constructor(props: any = {}) {
    super(props);

    this.id = props.uuid || this.id;
    this.sharerIsSelf = props.sharer?.is_self || props.sharerIsSelf;
    this.sharerDisplayName = props.sharer?.display_name || props.sharerDisplayName;
    this.sharedPublicly = props.shared || props.sharedPublicly;
    this.publicPermissions = props.permissions || props.publicPermissions;
    this.created = null;
    this.wasSharedDirectly = !!props.wasSharedDirectly;

    if (props.contacts) {
      this.contactsMap = OrderedMap(
        props.contacts.map((contact) => [contact.uuid, new SharedContact(contact)]),
      );
    } else {
      this.contactsMap = props.contactsMap || OrderedMap();
    }
  }

  get count() {
    return this.contactsMap.size;
  }
}
